module.exports = __webpack_public_path__ + "static/default-content-image-a5c2a2d255e889642e8000f24c97e23d.jpg";